/*
 * Copyright (c) 2021 JCA Electronics , Winnipeg, MB. All rights reserved.
 */
//SmartMap.WebService.Models.Models.ImplementOperationsModel

import { ConfigurationModel } from './ConfigurationModel';
import { Guid } from 'guid-typescript';
import { deserialize, deserializeArray, serialize } from 'class-transformer';
import { TwoTupleNumber } from '../../types/tuple';

export class ImplementOperationsModel {
  ErrorNotes: string;
  DistanceGPSToHitchX: number;
  DistanceGPSToHitchY: number;
  DistanceHitchToImplementCenterX: number;
  DistanceHitchToImplementCenterY: number;
  DistanceGPSToImplementCenterX: number;
  DistanceGPSToImplementCenterY: number;
  DistanceGPSToTractorBackY: number;
  LeftBuffer: number;
  RightBuffer: number;
  GPSOnTractor: boolean;
  ThreePointHitch: boolean;
  CreationTime: number;
  NumberOfZones: number;
  ImplementName: string;
  ImplementID: string;
  SectionMap: { [key: string]: number };
  SectionList: TwoTupleNumber[];
  SectionWidths: number[];
  ApplicationParameters: string;
  SectionControlConfiguration: ConfigurationModel;

  constructor() {
    this.ErrorNotes = '';
    this.ApplicationParameters = '';
    this.DistanceGPSToHitchX = 0;
    this.DistanceGPSToHitchY = 0;
    this.DistanceHitchToImplementCenterX = 0;
    this.DistanceHitchToImplementCenterY = 0;
    this.DistanceGPSToImplementCenterX = 0;
    this.DistanceGPSToImplementCenterY = 0;
    this.DistanceGPSToTractorBackY = 0;
    this.LeftBuffer = 0;
    this.RightBuffer = 0;
    this.GPSOnTractor = false;
    this.ThreePointHitch = false;
    this.CreationTime = 0;
    this.NumberOfZones = 0;
    this.ImplementName = '';
    this.ImplementID = Guid.EMPTY.toString();
    this.SectionMap = {};
    this.SectionList = [];
    this.SectionWidths = [];
    this.SectionControlConfiguration = new ConfigurationModel();
  }

  static toModel(json: string): ImplementOperationsModel {
    const model = deserialize(ImplementOperationsModel, json);
    return model;
  }

  static toModelCollection(json: string): ImplementOperationsModel[] {
    const models = deserializeArray(ImplementOperationsModel, json);
    return models;
  }

  fromModelToJson(): string {
    const jsObj = serialize(this);
    return jsObj;
  }
}
